import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NewsRecommendItem from "../../components/rich/NewsRecommendItem.vue";
import Classify from "../../components/Classify.vue";
export default {
  name: "News",
  components: {
    NewsRecommendItem: NewsRecommendItem,
    Classify: Classify
  },
  data: function data() {
    return {
      recommend: {
        first: {},
        lastFour: []
      },
      classifyList: [],
      classify: 0,
      page: 1,
      limit: 10,
      total: 0,
      news: [],
      topTwoHot: [],
      hotNews: [],
      index: 0
    };
  },
  computed: {
    navList: function navList() {
      return this.classifyList.slice(this.index, this.index + 5);
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var recommendNews, classifyList, items, hotNews;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$http.get("/api/app/information/recommend");

            case 2:
              recommendNews = _context.sent;

              if (recommendNews.length > 0) {
                this.recommend.first = recommendNews[0];
                this.recommend.lastFour = recommendNews.splice(1, 4);
              }

              _context.next = 6;
              return this.$http.get("/api/app/information/classify");

            case 6:
              classifyList = _context.sent;
              classifyList.unshift({
                name: "全部",
                id: 0
              });
              items = [{
                name: "资讯分类",
                id: "news",
                value: {
                  item: 0,
                  child: 0
                },
                children: classifyList
              }];
              this.classifyList = items;
              _context.next = 12;
              return this.$http.get("/api/app/information/hot");

            case 12:
              hotNews = _context.sent;
              this.topTwoHot = hotNews.splice(0, 2);
              this.hotNews = hotNews;

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  activated: function activated() {
    // 从缓存恢复时恢复滚动位置
    window.scrollTo(0, this.scrollTop);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 离开时保存滚动位置
    this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    next();
  },
  methods: {
    onClassifyChange: function () {
      var _onClassifyChange = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(_ref) {
        var _this = this;

        var id, value;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = _ref.id, value = _ref.value;
                console.log(id);
                this.classify = value.item;
                this.$nextTick(function () {
                  _this.$refs.list.searchRefresh();
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onClassifyChange(_x) {
        return _onClassifyChange.apply(this, arguments);
      }

      return onClassifyChange;
    }(),
    changeClassify: function () {
      var _changeClassify = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(classify) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.classify = classify.id;
                this.$nextTick(function () {
                  _this2.$refs.list.searchRefresh();
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function changeClassify(_x2) {
        return _changeClassify.apply(this, arguments);
      }

      return changeClassify;
    }(),
    navToLeft: function navToLeft() {
      if (this.index == 0) {
        return;
      }

      this.index--;
    },
    navToRight: function navToRight() {
      if (this.index >= this.classifyList.length - 5) {
        return;
      }

      this.index++;
    }
  }
};